import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callFunction } from "../lib/api";

interface CloseMatchResponse {
  id: string;
  status: string;
}

export const useCloseMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (matchId: string): Promise<CloseMatchResponse> => {
      const data = (await callFunction("/close-match", {
        method: "POST",
        body: JSON.stringify({ matchId }),
      })) as { status: string };

      return { ...data, id: matchId };
    },
    onSuccess: (_data, matchId) => {
      queryClient.invalidateQueries({ queryKey: ["matches"] });
      queryClient.invalidateQueries({ queryKey: ["match", matchId] });
    },
  });
};
